import { useEffect, useState, useContext } from 'react'
import { withRouter } from 'react-router-dom'
import * as H from 'history'
import { ContentBody, ContentHeader } from 'components/shared/content'
import { ExTable, TableBody, TableCell, TableHead, TableRow } from 'components/shared/widget'
import { useFetchRequestFormsApi, usePutRequestFormApi } from 'api/request_form'
import { RequestForm, RequestFormForm, RequestFormSearchForm } from 'entities/request_form'
import { Pagination } from 'components/shared/pagination'
import { useEffectSkipFirst, useForm, useQuery } from 'utils/hooks'
import { InputField } from 'components/shared/input'
import { Badge, Button, ButtonGroup, ProgressBar, ToggleButton } from 'react-bootstrap'
import moment from 'moment'
import { toDateText } from 'utils/util'
import { HomeProductSearchForm } from 'entities/home_product'
import { useFetchHomeProductsApi } from 'api/home_product'
import _ from 'lodash'
import { useFetchRequestFormIssuanceApi } from 'api/request_form_issuance'
import { GlobalStateContext } from 'contexts/global_state_context'

type Props = {
    history: H.History
}

const RequestFormsPage = (props: Props) => {
    const params = useQuery<RequestFormSearchForm>()
    const searchForm = useForm<RequestFormSearchForm>({ ...params, ordering: '-request_form_created_at' })
    const api = useFetchRequestFormsApi(searchForm)
    const [requestForms, setRequestForms] = useState<RequestForm[]>([])
    const homeProductSearchForm = useForm<HomeProductSearchForm>({ institutionId: params.institutionId })
    const homeProductsApi = useFetchHomeProductsApi(homeProductSearchForm)
    const productSelectForm = useForm<{ homeProductId: number | undefined }>({ homeProductId: undefined })
    const requestFormIssuanceApi = useFetchRequestFormIssuanceApi()
    const globalState = useContext(GlobalStateContext)

    useEffect(() => {
        api.execute()
        requestFormIssuanceApi.execute(Number(params.requestFormIssuanceId))
        homeProductsApi.execute()
    }, [])

    useEffectSkipFirst(() => {
        globalState.setLoading(api.loading)
        if (api.isSuccess()) {
            setRequestForms(api.response.results)
        }
    }, [api.loading])

    const getHomeProduct = () => {
        const hp = homeProductsApi.response.results.find((hp) => hp.id === productSelectForm.object?.homeProductId)
        return hp
    }

    return (
        <div>
            <ContentHeader
                headerTitle="キットの梱包"
                left={
                    <>
                        {/* <SearchConditionView searchForm={searchForm} onClickRemoveButton={handleClickRemoveFilter} hiddenSearchParams={['institutionId']} /> */}
                    </>
                }
                right={
                    <>
                        {searchForm.object.isNotSent ? (
                            <Button
                                variant="secondary"
                                onClick={() => {
                                    searchForm.update((f) => {
                                        delete f.isNotSent
                                        f.page = 1
                                    })
                                }}
                            >
                                すべて表示
                            </Button>
                        ) : (
                            <Button
                                variant="secondary"
                                onClick={() => {
                                    searchForm.update((f) => {
                                        f.isNotSent = true
                                        f.page = 1
                                    })
                                }}
                            >
                                未発送のみ表示
                            </Button>
                        )}
                    </>
                }
            />
            <div style={{ backgroundColor: getHomeProduct()?.color ? getHomeProduct()!.color + '55' : 'inherit', padding: 20, marginTop: 10 }}>
                <ButtonGroup>
                    {homeProductsApi.response.results
                        .filter((hp) => _.uniq(api.response.results.map((rf) => rf.customerOrder?.homeProductId)).includes(hp.id))
                        .map((hp) => {
                            return (
                                <ToggleButton
                                    key={'product-select' + hp.id}
                                    type="radio"
                                    variant={'outline-primary'}
                                    name="radio"
                                    value={String(hp.id)}
                                    checked={productSelectForm.object.homeProductId === hp.id}
                                    onChange={(e) => productSelectForm.updateObject('homeProductId', Number(e.currentTarget.value))}
                                    onClick={() => {
                                        productSelectForm.updateObject('homeProductId', hp.id)
                                    }}
                                >
                                    {hp.name}
                                </ToggleButton>
                            )
                        })}
                </ButtonGroup>
            </div>
            {productSelectForm.object.homeProductId && (
                <div>
                    <div style={{ marginTop: 10 }}>
                        <ProgressBar
                            max={100}
                            now={requestFormIssuanceApi.response.sentRate}
                            label={`${requestFormIssuanceApi.response.sentRate}%`}
                            style={{ width: '100%' }}
                        />
                    </div>
                    <ContentBody>
                        <ExTable className="sticky-table">
                            <TableHead>
                                <TableRow>
                                    <TableCell th width={60} align="center">
                                        ID
                                    </TableCell>
                                    <TableCell th width={120} align="center">
                                        送付日
                                    </TableCell>
                                    <TableCell th minWidth={200}>
                                        宛先
                                    </TableCell>
                                    <TableCell th width={100} align="center">
                                        コード
                                    </TableCell>
                                    <TableCell th width={200} align="center">
                                        確認用バーコード
                                    </TableCell>
                                    <TableCell th width={150} align="center">
                                        追跡番号
                                    </TableCell>
                                    <TableCell th width={100} align="center">
                                        ギフト
                                    </TableCell>
                                    <TableCell th width={120} align="center">
                                        クーポングループ
                                    </TableCell>
                                    <TableCell th width={250}>
                                        クーポン備考
                                    </TableCell>
                                    <TableCell th width={80}></TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody loading={false}>
                                {requestForms
                                    .filter((rf) => rf.customerOrder?.homeProductId === productSelectForm.object.homeProductId)
                                    .map((requestForm: RequestForm) => {
                                        return (
                                            <FormRow
                                                key={requestForm.id}
                                                requestForm={requestForm}
                                                onComplete={(rf) => {
                                                    api.execute()
                                                    requestFormIssuanceApi.execute(Number(params.requestFormIssuanceId))
                                                }}
                                            />
                                        )
                                    })}
                            </TableBody>
                        </ExTable>
                        <Pagination pageSet={api.pageSet} response={api.response}></Pagination>
                    </ContentBody>
                </div>
            )}
        </div>
    )
}

export default withRouter(RequestFormsPage)

type FormRowProps = {
    requestForm: RequestForm
    onComplete: (requestForm: RequestForm) => void
}

const FormRow = ({ requestForm, onComplete }: FormRowProps) => {
    const form = useForm<RequestFormForm>(requestForm)
    const api = usePutRequestFormApi()

    useEffectSkipFirst(() => {
        if (api.isSuccess()) {
            onComplete(form.object)
        }
    }, [api.loading])
    return (
        <TableRow key={`requestForm-${requestForm.id}`}>
            <TableCell align="center">{requestForm.id}</TableCell>
            <TableCell align="center">{toDateText(requestForm.sentAt)}</TableCell>
            <TableCell>
                {requestForm.customerOrder?.deliveryInfos?.length ? (
                    <>
                        <div>{`${requestForm.customerOrder.deliveryInfos[0]?.firstName} ${requestForm.customerOrder.deliveryInfos[0]?.lastName}`}</div>
                        <div>{requestForm.customerOrder.deliveryInfos[0]?.address?.whole}</div>
                    </>
                ) : (
                    <>
                        <div>{requestForm.customerOrder?.name}</div>
                        <div>{requestForm.customerOrder?.address?.whole}</div>
                    </>
                )}
            </TableCell>
            <TableCell align="center">{requestForm.code}</TableCell>
            <TableCell align="center">
                <InputField form={form} attr="checkCode" style={{ marginBottom: 0 }} placeholder="バーコードをスキャンしてください" />
            </TableCell>
            <TableCell align="center">
                <InputField form={form} attr="trackNumber" style={{ marginBottom: 0 }} />
            </TableCell>
            <TableCell align="center">
                {form.object.customerOrder?.customerPayment?.campaignGift && <Badge>{form.object.customerOrder?.campaignGift}</Badge>}
            </TableCell>
            <TableCell align="center">
                {form.object.customerOrder?.customerPayment?.coupon?.couponGroup?.name && (
                    <Badge>{form.object.customerOrder?.customerPayment?.coupon?.couponGroup?.name}</Badge>
                )}
            </TableCell>
            <TableCell>{form.object.customerOrder?.customerPayment?.coupon?.remarks && form.object.customerOrder?.customerPayment?.coupon?.remarks}</TableCell>
            <TableCell align="center">
                <Button
                    disabled={form.object.checkCode !== requestForm.code}
                    size="sm"
                    variant="success"
                    onClick={() => {
                        api.execute({ ...form.object, sentAt: moment().format('YYYY-MM-DD HH:mm:ss') })
                    }}
                >
                    登録
                </Button>
            </TableCell>
        </TableRow>
    )
}
